import { Component, OnInit } from '@angular/core';
import {CampService} from '../../model/CampService';
import {VnaPortalSelected} from '../../../../../core/data/messaging/VnaPortalSelected';
import {Location} from '@angular/common';
import {MessagingService} from '../../../../../core/service/messaging.service';
import {ActivatedRoute, Router} from '@angular/router';
import {VnaCampaignActionService} from '../../services/vna-campaign-action.service';
import {CampAction} from '../../model/CampAction';

@Component({
  selector: 'app-edit-campaign-action',
  templateUrl: './edit-campaign-action.component.html',
  styleUrls: ['./edit-campaign-action.component.scss']
})
export class EditCampaignActionComponent implements OnInit {

    params: Object = {};
    enabled: boolean = false;
    action: CampAction;

    actionName: string = '';

    constructor(private activatedRoute: ActivatedRoute,
                private actionHandler: VnaCampaignActionService,
                private messaging:MessagingService,
                private location: Location,
                private router:Router) { }

    ngOnInit() {
        this.activatedRoute.params.subscribe(
            (params) => {
                this.params = params;
                this.enabled = true;
                this.actionHandler.findMergedActionCampaign(this.params['pkAction']).subscribe(
                    (result) => {
                        this.action = new CampAction(result);
                        this.actionName = (this.action.getTypeAction() == 'FILE') ? this.action.getActionFilename() : this.action.getActionName();
                        this.enabled = false;
                    }
                )
            }
        );
        this.messaging.message.subscribe(
            (result) => {
                if(result instanceof VnaPortalSelected && !result.isTheFirst() && this.location.path().match(/phone\/config\/campaign/g)){
                    this.router.navigateByUrl('/phone/config/campaigns');

                }
            }
        )
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna-campaign/components/edit-campaign-action/edit-campaign-action.component.ts